<script setup lang="ts">

import { TagLine } from "@components/TagLine";

</script>

<template>

    <div class="max-w-5xl mx-auto text-center tracking-wider pt-8 pb-16 md:pt-16 px-4">
        <div class="text-4xl md:text-6xl font-semibold">
            It's <span class="text-primary-600 uppercase font-bold">Simple.</span>
        </div>
        <div class="text-4xl md:text-6xl font-semibold mt-4">
            It keeps your car healthy and 
            <span class="inline md:hidden">earns you rewards as you drive.</span>
        </div>
        <div class="hidden md:block text-4xl md:text-6xl font-semibold mt-4">
            you earn rewards as you drive.
        </div>
        <TagLine />
    </div>

</template>